// extracted by mini-css-extract-plugin
export default {"Visual":"Visual-module__Visual--aJqBf","Image":"Visual-module__Image--Gfodt"};